
import React from "react";
import { Card } from "react-bootstrap";

export default function AboutUs() {
  return (
    <Card className="mb-3">
      <Card.Header>
        <h3 className="text-primary-label">About Us</h3>
      </Card.Header>
      <Card.Body>
        <p>
          <strong>Lupie Community</strong> is a smart platform designed to simplify life in gated communities and apartments.
          We connect residents, committees, and service providers through a secure and user-friendly app.
        </p>
        <h5>Our Mission</h5>
        <p>
          To create a connected, safe, and efficient living experience for residents by providing internal and external services seamlessly.
        </p>
        <h5>What We Offer</h5>
        <ul>
          <li>Visitor and security management.</li>
          <li>Community announcements and event scheduling.</li>
          <li>Service booking for maintenance, housekeeping, and more.</li>
        </ul>
        <h5>Why Choose Lupie?</h5>
        <p>
          We prioritize privacy, convenience, and innovation to make community living stress-free and enjoyable.
        </p>
      </Card.Body>
    </Card>
  );
}
